export interface UTMParams {
  utm_source?: string;
  utm_campaign?: string;
  utm_adset?: string;
  utm_ad?: string;
}

export function captureUTMs(): UTMParams {
  if (typeof window === 'undefined') return {};
  
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get('utm_source') || undefined,
    utm_campaign: params.get('utm_campaign') || undefined,
    utm_adset: params.get('utm_adset') || undefined,
    utm_ad: params.get('utm_ad') || undefined
  };
}

export function track(event: string, payload?: Record<string, any>) {
  if (typeof window === 'undefined') return;
  
  const timestamp = new Date().toISOString();
  console.log('[TRACKING]', { event, timestamp, ...payload });
  
  // In production, send to your analytics service
  // Example: analytics.track(event, payload);
}
